module.exports = __webpack_public_path__ + "img/changeGrooves-1.6d0c340.png";